/* tslint:disable */

/**
 */
export class Shelves {
    ID_SHELVES?: number;
    ID_EQUIP?: number;
    SPACE?: number;
    NB?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/shelves.ts